export enum Intersect {
  None = 0,
  Left = 1,
  Top = 2,
  Right = 4,
  Bottom = 8,
  Inside = 16,
}
